import { useQuery } from '@hooks/reactQuery';

import { getCrowdCellPresets } from '@api/crowdCellPresets';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { ISearchValue } from '@interfaces/common/store';
import { ICrowdCellsConfigPreset } from '@interfaces/crowdcell/crowdCells';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EErrorCodes } from '@enums/errorCodes';

import { CROWD_CELL_PRESETS } from '@constants/queryKeys';

export interface IUseConfigPresetsResult {
	presets: ICrowdCellsConfigPreset[];
	isLoadingPresets: boolean;
	count: number;
}

export function useConfigPresets({ searchValue }: ISearchValue): IUseConfigPresetsResult {
	const { data, isFetching } = useQuery<{ items: ICrowdCellsConfigPreset[]; count: number }>({
		queryKey: [
			CROWD_CELL_PRESETS,
			searchValue,
		],
		queryFn: () => getCrowdCellPresets({ searchValue }),
		onError: (err: IResponseError) => {
			if (!err?.errors.find((item) => item.code === EErrorCodes.goldenSettingsNotSet)) {
				handleErrorFromMessage(err);
			}
		},
		select: (data) => {
			return {
				items: data
					? data.items
						.map((preset: ICrowdCellsConfigPreset) => ({
							...preset,
							label: preset.name,
							value: preset.id,
						}))
						.sort((prev, next) => next.createdAt - prev.createdAt)
					: [],
				count: data?.count || 0,
			};
		},
	});

	return {
		presets: data ? data.items : [],
		count: data?.count || 0,
		isLoadingPresets: isFetching,
	};
}
